var components;
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"public-logo-img",attrs:{"src":require("../static/logo.png"),"alt":""}})}
var recyclableRender = false
var staticRenderFns = []

export { render, staticRenderFns, recyclableRender, components }